import React, { useEffect, useState, useContext } from 'react';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useHistory } from 'react-router-dom';
import ProgressBar from './ProgressBar';
import './style.css';
import { getFile } from '@opu/utils';
import StarsComponent from '../startComponent/StarsComponent';
import AxiosInstance from '../../helpers/AxiosInstance';
import { AuthContext } from '../../Main';

const BookComponent = ({ data, reviewBoolean, readBoolean, widthWindow = 2000, variant = 'card' }) => {
  const { id, title, nbrViews = 0, rating = 0, cover, authors, bookFavorite = false, bookView = 0, pages, price = 0 } = data;
  const [newRating, setNewRating] = useState(rating);
  const [newFavorite, setNewFavorite] = useState(bookFavorite);
  const [imageLoading, setImageLoading] = useState(true);
  const { isAuth } = useContext(AuthContext);
  let history = useHistory();

  // Check if book has a price and should show purchase button
  const hasPrice = price > 0;
  
  const getBookPrice = () => {
    return price || 0;
  };

  const handlePurchase = (bookId, bookTitle) => {
    if (!isAuth) {
      // For non-authenticated users, redirect to visitor purchase page
      history.push(`/visitor/books?bookId=${bookId}`);
    } else {
      // For authenticated users, redirect to book details page
      history.push('/book-details/' + bookId);
    }
  };

  const goToBookDetails = () => {
    history.push('/book-details/' + id);
  };

  const addToFavorite = () => {
    if (newFavorite) {
      AxiosInstance.delete('/book/remove-from-favorite/' + id)
        .then((response) => {
          setNewFavorite(false);
        })
        .catch((error) => {
          return;
        });
    } else {
      AxiosInstance.post('/book/add-to-favorite/' + id)
        .then((response) => {
          setNewFavorite(true);
        })
        .catch((error) => {
          return;
        });
    }
  };
  return (
    <div className={`book-item-container${variant === 'shelf' ? ' is-shelf' : ''}`}>
      <div className="book-item-container-image">
        <img
          src={cover && cover.trim() ? getFile('book', cover) : '/assets/images/book_default.png'}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/assets/images/book_default.png';
            setImageLoading(false);
          }}
          onLoad={(e) => {
            // Image loaded successfully
            e.target.style.opacity = '1';
            setImageLoading(false);
          }}
          alt={title || 'Book cover'}
          onClick={goToBookDetails}
          style={{ 
            opacity: imageLoading ? '0.3' : '1',
            transition: 'opacity 0.3s ease'
          }}
        />
        {imageLoading && (
          <div className="image-loading-placeholder">
            <div className="loading-spinner"></div>
          </div>
        )}
        {newFavorite ? (
          <FavoriteIcon className="book-favorite active" onClick={addToFavorite} />
        ) : (
          <FavoriteBorderIcon className="book-favorite" onClick={addToFavorite} />
        )}
        {hasPrice && !isAuth && (
          <button
            type="button"
            className="shelf-price"
            onClick={(e) => {
              e.stopPropagation();
              handlePurchase(id, title);
            }}
          >
            {getBookPrice()} DA
          </button>
        )}
      </div>
      <div className="book-container-description">
        {authors.length > 0 ? (
          <div className="book-container-author">{authors[0].name} </div>
        ) : (
          <div className="book-container-author"> &nbsp;</div>
        )}
        <div className="book-container-name-book ">
          <span className="text-ellipsizeMode" title={title} onClick={goToBookDetails}>
            {title ? <>{title}</> : <>&nbsp;</>}
          </span>
        </div>
        {variant !== 'shelf' && reviewBoolean && (
          <div className="book-review-container">
            <StarsComponent value={newRating} onClick={null} />
            <div className="book-views">
              {nbrViews}&nbsp;
              <VisibilityIcon className="view-eye-icon" />
            </div>
          </div>
        )}
        {variant !== 'shelf' && (
          <>
            <div className="book-reading-container">
              {readBoolean && <ProgressBar value={bookView} numberPage={pages} />}
              <br />
              <div className="hide-on-mobile">
                <br />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BookComponent;
